import React from 'react';
import PropTypes from 'prop-types';

import numeral from 'numeral';
import displayName from 'component-lib/displayName';
import withMessages, { FormattedHTMLMessage } from 'component-utilities/intl';

import DropdownFooter from '../DropdownFooter';
import DropdownFooterText from '../DropdownFooterText';
import ExportPagination from './ExportPagination';

const BASE_KEY = 'components.dropdowns.export.footer';

function component({
    assetLimit,
    getMessage,
    isDisabled,
    onBack,
    onNext,
    onSubmit,
}) {
    return (<div data-export-limit={assetLimit}>
        <DropdownFooter>
            <ExportPagination
                isDisabled={isDisabled}
                onBack={onBack}
                onNext={onNext}
                onSubmit={onSubmit}
            />
            <DropdownFooterText
                text={
                    <FormattedHTMLMessage
                        id={`${BASE_KEY}.asset_limit`}
                        values={{ assetLimit: numeral(assetLimit).format('0a') }}
                    />
                }
                tooltipText={getMessage(`${BASE_KEY}.tooltip`)}
            />
        </DropdownFooter>
    </div>)
}

component.propTypes = {
    assetLimit: PropTypes.number.isRequired,
    getMessage: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
    onBack: PropTypes.func,
    onNext: PropTypes.func,
    onSubmit: PropTypes.func,
};

component.defaultProps = {
    isDisabled: void 0,
    onBack: void 0,
    onNext: void 0,
    onSubmit: void 0,
};

const ExportFooter = withMessages(component);
ExportFooter.displayName = displayName('Dropdowns/Exports/ExportDropdownFooter',);

export default ExportFooter;
